var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTypeB(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 49,
    viewBox: "0 0 50 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.959,
    cy: 24.5,
    r: 22.3047,
    stroke: "white",
    strokeWidth: 4.3906
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0658 8.27278C27.2107 8.27278 29.3346 8.69526 31.3163 9.51609C33.2979 10.3369 35.0985 11.54 36.6152 13.0567C38.1319 14.5734 39.335 16.374 40.1558 18.3556C40.9766 20.3373 41.3991 22.4612 41.3991 24.6061L25.0658 24.6061L25.0658 8.27278Z",
    fill: "#F2CA88"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypeB);
export default __webpack_public_path__ + "static/media/typeB.cc2279b27f2b6bfc534f5116a0d4f8d0.svg";
export { ForwardRef as ReactComponent };